import { Vue } from 'vue-property-decorator';


Vue.filter('firstUpperCase', (val) => {
  if (!val) { return; }
  return val.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
});
